import { useEffect, useState } from "react";
import { History } from "lucide-react";
import { endpoints } from "@/lib/api";
import { PageHeader, Card, Loading, Empty, handleErr } from "./AdminUI";

const ACTION_CLS = {
  create: "text-emerald-400", edit: "text-sky-400", delete: "text-red-400",
  submit: "text-amber-400", verify: "text-sky-400", approve: "text-emerald-400", reject: "text-red-400",
  staff_create: "text-emerald-400", staff_update: "text-sky-400", staff_delete: "text-red-400",
  staff_promote: "text-emerald-400", staff_demote: "text-amber-400",
};
const MODULE_OPTS = ["", "news", "shows", "events", "voting", "journalists", "schedule", "programs", "staff"];

export default function AdminActivity() {
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(true);
  const [module, setModule] = useState("");

  useEffect(() => {
    setLoading(true);
    endpoints.adminActivity({ module: module || undefined, limit: 300 })
      .then((r) => setRows(r.data || [])).catch(handleErr).finally(() => setLoading(false));
  }, [module]);

  return (
    <div>
      <PageHeader title="Activity Log" desc="Every create, edit, verify, approve and staff change — who did what, and when">
        <select value={module} onChange={(e) => setModule(e.target.value)} data-testid="activity-module-filter"
          className="h-10 rounded-lg bg-[#0A0C10] border border-[#273042] px-3 text-white text-sm outline-none">
          {MODULE_OPTS.map((m) => <option key={m} value={m}>{m ? m[0].toUpperCase() + m.slice(1) : "All modules"}</option>)}
        </select>
      </PageHeader>
      {loading ? <Loading /> : rows.length === 0 ? <Empty text="No activity recorded yet." /> : (
        <Card className="divide-y divide-[#273042]">
          {rows.map((a) => (
            <div key={a.id} data-testid={`activity-${a.id}`} className="p-3.5 flex items-center justify-between gap-3">
              <div className="min-w-0 flex items-center gap-3">
                <History className="w-4 h-4 text-slate-500 shrink-0" />
                <div className="min-w-0">
                  <div className="text-sm text-white truncate">
                    <span className="font-semibold">{a.actorName}</span>{" "}
                    <span className={`font-bold ${ACTION_CLS[a.action] || "text-slate-300"}`}>{a.action.replace("_", " ")}</span>{" "}
                    <span className="text-slate-400">{a.module}</span>
                    {a.targetTitle && <span className="text-slate-300"> — “{a.targetTitle}”</span>}
                  </div>
                  {a.meta?.reason && <div className="text-xs text-red-400">Reason: {a.meta.reason}</div>}
                </div>
              </div>
              <div className="text-xs text-slate-500 shrink-0">{a.at ? new Date(a.at).toLocaleString() : ""}</div>
            </div>
          ))}
        </Card>
      )}
    </div>
  );
}
